export function isFullRoute(input) {
    const validHash = input.hasOwnProperty('hash')
        ? input.hash === undefined || typeof input.hash === 'string'
        : true;
    const validSearch = input.hashOwnProperty('search')
        ? typeof input.search === 'object' ||
            Object.keys(input.search).every((key) => typeof input.search[key] === 'string')
        : true;
    const validPaths = input.hasOwnProperty('paths') &&
        Array.isArray(input.paths) &&
        input.paths.every((path) => typeof path === 'string');
    return validHash && validSearch && validPaths;
}
